'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { Link } from '@repo/ui/components/link/link';
import { useAuth } from '@repo/ui-web/auth/auth-hooks';
import { getUserAvatarUrl } from '@repo/utility/image-urls';
import { useEffect, useState } from 'react';
import { MapsAuthModal } from '../components/maps-auth-modal';
export const MapTopBarUserAvatar = () => {
  const $ = _c(13);
  const {
    user,
    loading
  } = useAuth();
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["common"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useT(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!mounted) {
    return null;
  }
  let t3;
  if ($[3] !== loading || $[4] !== t || $[5] !== user) {
    t3 = loading ? <div className={css({
      width: "[32px]",
      height: "[32px]"
    })} /> : user ? <Link href="/account"><img src={getUserAvatarUrl(user.profileImage)} alt="User avatar" className={css({
        borderRadius: "full",
        width: "[32px]",
        height: "[32px]"
      })} width={32} height={32} /></Link> : <Button variant="ghost" onClick={() => setIsLoginModalOpen(true)} color="primary"><Icon icon="person_outline" decorative={true} />{t(_temp)}</Button>;
    $[3] = loading;
    $[4] = t;
    $[5] = user;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = details => setIsLoginModalOpen(details.open);
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isLoginModalOpen) {
    t5 = <MapsAuthModal isOpen={isLoginModalOpen} onOpenChange={t4} trigger="map-login" size="sm" />;
    $[8] = isLoginModalOpen;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
function _temp($) {
  return $.login;
}